import {isNotNil} from 'ramda-adjunct';

import {ROWS_PER_PAGE} from '@dms/api/core';

type GetSourcingTableListScrollStateParams = {
  dataLength: number;
  count?: number | null;
  isEndReached?: boolean;
};

export type SourcingTableListScrollState = {
  usesListEndMetadata: boolean;
  hasMoreRows: boolean;
  hiddenVehiclesCount: number;
  showTerminalFooter: boolean;
  showHiddenVehiclesMessage: boolean;
};

export function getSourcingTableListScrollState(
  params: GetSourcingTableListScrollStateParams
): SourcingTableListScrollState {
  const usesListEndMetadata = isNotNil(params.isEndReached);
  // All Offers: isEndReached is the sole pagination gate — optimistic hide can shrink
  // dataLength below ROWS_PER_PAGE while more server pages still exist.
  const hasMoreRows = usesListEndMetadata
    ? params.isEndReached !== true
    : params.dataLength >= ROWS_PER_PAGE && params.dataLength < (params.count ?? 0);
  const hiddenVehiclesCount = Math.max((params.count ?? 0) - params.dataLength, 0);
  const isListTerminal = usesListEndMetadata
    ? params.isEndReached === true
    : isNotNil(params.count) &&
      params.dataLength >= ROWS_PER_PAGE &&
      params.dataLength >= params.count;
  const showHiddenVehiclesMessage =
    isListTerminal && usesListEndMetadata && hiddenVehiclesCount > 0;
  // Single-page lists do not need an end-of-list marker; show it only after scrolling
  // or when hidden rows explain a count/visible-row mismatch.
  const showTerminalFooter =
    showHiddenVehiclesMessage || (isListTerminal && params.dataLength > ROWS_PER_PAGE);

  return {
    usesListEndMetadata,
    hasMoreRows,
    hiddenVehiclesCount,
    showTerminalFooter,
    showHiddenVehiclesMessage,
  };
}
